import React from 'react';
import './WebServices.css';
import RevealOnScroll from './RevealOnScroll';
import { 
  Code, 
  Globe, 
  ShoppingCart, 
  Cloud, 
  Database, 
  FigmaLogo 
} from '@phosphor-icons/react';

const webServices = [
  {
    icon: <Code size={32} weight="duotone" />,
    title: "Custom Web App Development",
    description: "Tailored digital solutions built with precision. We engineer scalable, high-performance web applications using modern stacks like MERN and MEAN to solve unique business challenges."
  },
  {
    icon: <Globe size={32} weight="duotone" />,
    title: "Enterprise Web Portals",
    description: "Robust internal and customer-facing portals that streamline operations. From complex CRM integrations to legacy system migrations, we build tools that empower enterprise productivity."
  },
  {
    icon: <ShoppingCart size={32} weight="duotone" />,
    title: "Advanced E-commerce Platforms",
    description: "Conversion-optimized storefronts that redefine online retail. We specialize in headless commerce, secure payment gateways, and intelligent inventory systems for high-growth brands."
  },
  {
    icon: <Cloud size={32} weight="duotone" />,
    title: "SaaS Product Engineering",
    description: "Cloud-native architectures designed for multi-tenancy and scale. We help startups and enterprises build and launch software products with resilient, serverless backends."
  },
  {
    icon: <Database size={32} weight="duotone" />,
    title: "API Development & Integration",
    description: "Seamless connectivity for your digital ecosystem. We design robust REST and GraphQL APIs and integrate third-party services to ensure fluid data flow and enhanced functionality."
  },
  {
    icon: <FigmaLogo size={32} weight="duotone" />,
    title: "UI/UX Strategy & Design",
    description: "User-centric designs that drive engagement. Our design process blends research-driven UX with stunning UI aesthetics to ensure your digital platform is both beautiful and functional."
  }
];

const WebServices = () => {
  return (
    <section className="web-services" id="services">
      <div className="services-header">
        <RevealOnScroll>
          <span className="services-tag">[ What We Do ]</span>
          <h2 className="services-main-title">Bespoke Web Development Solutions</h2>
          <p className="services-subtitle">
            We combine innovative design with robust engineering to build 
            future-proof digital experiences that drive measurable results.
          </p>
        </RevealOnScroll>
      </div>

      <div className="services-grid">
        {webServices.map((service, index) => (
          <RevealOnScroll key={index} delay={index * 100}>
            <div className="service-card">
              <div className="service-icon-wrapper">
                {service.icon}
              </div>
              <h3 className="service-card-title">{service.title}</h3>
              <p className="service-card-desc">{service.description}</p>
            </div>
          </RevealOnScroll>
        ))}
      </div>
    </section>
  );
};

export default WebServices;
